import React, { Component } from 'react';
import { Grid, Row, Image, Glyphicon } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { categoryActions as actions } from '../../actions';
import AuthService from '../../services/auth.service';
import LoadingListener from '../../helpers/loadingListener';
import { LoadingIcon } from '../LoadingIcon';
import BecomeCustomerModal from './BecomeCustomerModal';
import '../../content/css/PickContractType.css';

var images = [
    require("../../content/images/iconmonstr-product-1.svg"),
    require("../../content/images/iconmonstr-product-3.svg"),
    require("../../content/images/iconmonstr-briefcase-1.svg"),
    require("../../content/images/iconmonstr-briefcase-3.svg"),
    require("../../content/images/iconmonstr-download-6.svg"),
    require("../../content/images/iconmonstr-upload-6.svg"),
    require("../../content/images/iconmonstr-delivery-5.svg"),
    require("../../content/images/iconmonstr-delivery-6.svg"),
    require("../../content/images/iconmonstr-cloud-13.svg"),
    require("../../content/images/iconmonstr-cloud-30.svg"),
    require("../../content/images/personal_service_2.svg"),
    require("../../content/images/goods_and_rawmaterials.svg"),
    require("../../content/images/carrier_agreement_icon.svg"),
    require("../../content/images/broker_agreement_icon.svg")
];

class ContractTypePicker extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedType: null,
            lastSelectedType: null,
            showBecomeCustomerModal: false
        };

        this.authService = new AuthService();
        this.loadingListener = new LoadingListener([], true);
    }

    componentDidMount() {
        if (this.props.contractTypes.length === 0) {
            this.props.requestContractTypes();
        }
    }

    handleModalClose = () => {
        this.setState({ showBecomeCustomerModal: false });
    }

    handleSelectType = (type) => {
        let isAvailable = type && type.isAvailable;
        let hasChildren = this.hasChildren(type);

        if (!type || isAvailable || hasChildren)
            this.setState({ selectedType: type, lastSelectedType: this.state.selectedType });

        if (isAvailable) {
            this.props.onSelect(type, hasChildren);
        }

        if (type && !isAvailable && !hasChildren) {
            let self = this;
            setTimeout(() => {
                self.setState({ showBecomeCustomerModal: true });
            }, 300);
        }
    }

    getActiveClass = (type) => {
        let parent = Object.values(this.props.contractTypes).filter(x => this.hasChildren(x) && Object.values(x.children).some(y => y.contractType == this.props.selectedType))[0];
        let isSelected = this.props.selectedType === type || (this.state.selectedType == null && parent && parent.contractType == type);
        return "contract-type-box " + (isSelected ? "active" : "");
    }

    getContractTypes = () => {
        const hasChildren = this.state.selectedType && this.hasChildren(this.state.selectedType);
        let list = Object.values(hasChildren ? this.state.selectedType.children : this.props.contractTypes);
        list.forEach(x => {
            x.onClick = () => this.handleSelectType(x);
            x.className = this.getActiveClass(x.contractType);
        });

        //Group into pairs.
        list = list.reduce(function (result, value, index, array) {
            if (index % 2 === 0)
                result.push(array.slice(index, index + 2));
            return result;
        }, []);

        return list.map((x, i) => (<Row>{this.getContractType(x[0])}{this.getContractType(x[1])}</Row>));
    }

    getContractType = (type) => {
        if (!type) return;
        let isGuest = this.authService.isGuest();

        return (<div className={type.className} onClick={type.onClick}>
            <Image src={this.getImage(type.image)} />
            <div>
                <h3>{type.title}</h3>
                <p>{type.text}</p>
            </div>
            {type.isBeta && !isGuest && <div className="ribbon blue"><span>Beta</span></div>}
            {isGuest && !type.isAvailable && <div className="ribbon purple"><span><Glyphicon glyph="lock" /></span></div>}
        </div>);
    }

    hasChildren = (type) => {
        return type && type.children && type.children.length > 0;
    }

    getImage = (filename) => {
        return images.filter(x => x.includes(filename))[0];
    }

    render() {
        let isLoading = this.loadingListener.isLoading(this.props.isLoading);
        let isGuest = this.authService.isGuest();
        const subtitleIfNoThemes = "There are no themes available for you. Contact us for help.";
        let subtitle = !isLoading && this.props.contractTypes.length == 0 ? subtitleIfNoThemes : this.props.subtitle;

        return (
            <Grid className="contract-type-container">
                {this.props.title &&
                    <h1>{this.props.title}</h1>
                }
                <span>{subtitle}</span>
                {isLoading && <LoadingIcon />}
                {!isLoading && this.getContractTypes()}
                {!isLoading && this.state.selectedType &&
                    <button type="button" className="btn btn-labeled btn-default btn-back select-type" onClick={() => this.handleSelectType(this.state.lastSelectedType)}>
                        <span className="btn-label"><Glyphicon glyph="chevron-left" /></span>Back to other themes
                    </button>
                }
                {this.props.tipText &&
                    <p><b>Tip</b>: {this.props.tipText}</p>
                }
                {this.props.guestText && isGuest &&
                    <p>{this.props.guestText}</p>
                }
                <BecomeCustomerModal
                    show={this.state.showBecomeCustomerModal}
                    onClose={this.handleModalClose} />
            </Grid>
        );
    }
}

export default connect(
    state => state.category,
    dispatch => bindActionCreators(actions, dispatch)
)(ContractTypePicker);


// WEBPACK FOOTER //
// ./src/components/Misc/ContractTypePicker.js